import React, { Component } from 'react';

import { withStyles } from '@material-ui/core/styles';
import { DynamicList, ListItem } from 'sm-react-components';
import { setStorage, getStorage } from '../../infrastructure/storageService';
import * as requests from '../../infrastructure/requests';
import * as formatters from '../formatters';
import { Typography, Tooltip } from '@material-ui/core';
import TruckImage from '../../static/images/truck.svg';
import ServiceImage from '../../static/images/Service.svg';
import POI from '../../static/images/POI.svg';
import IconButton from '@material-ui/core/IconButton';
import Info from '@material-ui/icons/InfoOutlined';
import { Redirect } from 'react-router-dom';

const styles = {
    itemIcon: {
        height: '100%',
        padding: '10px',
        display: 'inline-block',
        verticalAlign: 'middle'
    },
    content: {
        height: '300px'
    },
    fullHeight: {
        height: '100%'
    },
    listItem: {
        borderBottom: '1px solid #D7DAE2',
        padding: '0px'
    },
    executionType: {
        height: '100%',
        display: 'inline-block',
        width: '25%',
        paddingLeft: '5px',
        paddingRight: '5px',
        verticalAlign: 'middle'
    },
    itemTime: {
        height: '100%',
        display: 'inline-block',
        width: '17%',
        paddingLeft: '2px',
        paddingRight: '2px',
        verticalAlign: 'middle'
    },
    itemOptions: {
        width: '35px',
        position: 'absolute',
        right: '8px',
        verticalAlign: 'middle'
    },
    ellipsis: {
        height: '100%',
        width: '100%',
        whiteSpace: 'nowrap',
        overflow: 'hidden !important',
        textOverflow: 'ellipsis',
        overflowWrap: 'break-word',
        wordWrap: 'break-word',
        lineHeight: '1.5'
    }
};

class RequestsList extends Component {
  bottomDiv = React.createRef();

  state = {
      selected:
      getStorage('requestSelected') &&
      JSON.parse(getStorage('requestSelected')),
      redirect: undefined,
      itemMouseOver: undefined
  };

  handleSelection = async (key, idx) => {
      const { onRequestSelected } = this.props;
      this.setState({ selected: key });
      setStorage('requestSelected', JSON.stringify(key));
      onRequestSelected && onRequestSelected(key);
  };

  handleMouseOver = (item, idx) => {
      this.setState({
          itemMouseOver: item
      });
  };

  scrollToBottom = () => {
      if (this.bottomDiv.current !== null) {
          this.bottomDiv.current.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
              inline: 'center'
          });
      }
  };

  doDate = item => {
      return formatters.localeDate(item.created);
  };

  renderDate = item => {
      const date = this.doDate(item);
      return (
          <ListItem key={'date-' + date}>
              <Typography variant="h5">{date}</Typography>
          </ListItem>
      );
  };

  renderOptimizerV1 = (item, idx) => {
      const { classes } = this.props;
      const { selected, itemMouseOver } = this.state;
      return (
          <ListItem
              key={item.id}
              className={classes.listItem}
              onClick={() => this.handleSelection(item, idx)}
              onMouseOver={() => this.handleMouseOver(item, idx)}
              selected={selected && selected.id === item.id}
          >
              <span className={classes.itemIcon}>
                  {formatters.status(item.status, item.testMode)}
              </span>
              <span className={classes.executionType}>
                  <Typography variant="body1" className={classes.ellipsis}>
                      {item.request}
                  </Typography>
                  {item.testMode && (
                      <Typography style={{ fontSize: '9px' }} variant="body1">
              test mode
                      </Typography>
                  )}
              </span>
              <span className={classes.itemTime}>
                  <Typography variant="body1">
                      {formatters.timestampToHoursSeconds(item.updated)}
                  </Typography>
              </span>
              <span className={classes.itemTime}>
                  <Tooltip title="Number of vehicles">
                      <img
                          src={TruckImage}
                          alt=""
                          style={{
                              height: '24px',
                              display: 'inline-block',
                              verticalAlign: 'middle'
                          }}
                      />
                  </Tooltip>
                  <Typography
                      variant="body1"
                      style={{
                          display: 'inline-block',
                          paddingLeft: '8px',
                          verticalAlign: 'middle'
                      }}
                  >
                      {item.metadata.vehicles}
                  </Typography>
              </span>
              <span className={classes.itemTime}>
                  <Tooltip title="Number of services">
                      <img
                          src={ServiceImage}
                          alt=""
                          style={{
                              height: '24px',
                              display: 'inline-block',
                              verticalAlign: 'middle'
                          }}
                      />
                  </Tooltip>
                  <Typography
                      variant="body1"
                      style={{
                          display: 'inline-block',
                          paddingLeft: '8px',
                          verticalAlign: 'middle'
                      }}
                  >
                      {item.metadata.services}
                  </Typography>
              </span>
              <span className={classes.itemOptions}>
                  {itemMouseOver && itemMouseOver.id === item.id && (
                      <IconButton
                          style={{ padding: 2, height: '35px', width: '35px' }}
                          onClick={() => {
                              this.setState({
                                  redirect: '/console/activity/execution/' + selected.id
                              });
                          }}
                      >
                          <Info />
                      </IconButton>
                  )}
              </span>
          </ListItem>
      );
  };

  rendererDefault = (item, idx) => {
      const { classes } = this.props;
      const { selected } = this.state;
      return (
          <ListItem
              key={item.id}
              className={classes.listItem}
              onClick={() => this.handleSelection(item, idx)}
              selected={selected && selected.id === item.id}
          >
              <span className={classes.itemIcon}>
                  {formatters.status(item.status, item.testMode)}
              </span>
              <span className={classes.executionType}>
                  <Typography variant="body1" className={classes.ellipsis}>
                      {item.request}
                  </Typography>
              </span>
              <span className={classes.itemTime}>
                  <Typography variant="body1">
                      {formatters.timestampToHoursSeconds(item.updated)}
                  </Typography>
              </span>
              <span className={classes.itemOptions}>
                  {selected && selected.id === item.id && (
                      <IconButton
                          style={{ padding: 2, height: '35px', width: '35px' }}
                          onClick={() => {
                              this.setState({
                                  redirect: '/console/activity/execution/' + selected.id
                              });
                          }}
                      >
                          <Info />
                      </IconButton>
                  )}
              </span>
          </ListItem>
      );
  };

  renderPlacesProfilerV1 = (item, idx) => {
      const { classes } = this.props;
      const { selected, itemMouseOver } = this.state;
      return (
          <ListItem
              key={item.id}
              className={classes.listItem}
              onClick={() => this.handleSelection(item, idx)}
              onMouseOver={() => this.handleMouseOver(item, idx)}
              selected={selected && selected.id === item.id}
          >
              <span className={classes.itemIcon}>
                  {formatters.status(item.status, item.testMode)}
              </span>
              <span className={classes.executionType}>
                  <Typography variant="body1" className={classes.ellipsis}>
                      {item.request}
                  </Typography>
                  {item.testMode && (
                      <Typography style={{ fontSize: '9px' }} variant="body1">
              test mode
                      </Typography>
                  )}
              </span>
              <span className={classes.itemTime}>
                  <Typography variant="body1">
                      {formatters.timestampToHoursSeconds(item.updated)}
                  </Typography>
              </span>
              <span className={classes.itemTime}>
                  <Tooltip title="Number of vehicles">
                      <img
                          src={TruckImage}
                          alt=""
                          style={{
                              height: '24px',
                              display: 'inline-block',
                              verticalAlign: 'middle'
                          }}
                      />
                  </Tooltip>
                  <Typography
                      variant="body1"
                      style={{
                          display: 'inline-block',
                          paddingLeft: '8px',
                          verticalAlign: 'middle'
                      }}
                  >
                      {item.metadata.routes}
                  </Typography>
              </span>
              <span className={classes.itemTime}>
                  <Tooltip title="Number of places">
                      <img
                          src={POI}
                          alt=""
                          style={{
                              height: '24px',
                              display: 'inline-block',
                              verticalAlign: 'middle'
                          }}
                      />
                  </Tooltip>
                  <Typography
                      variant="body1"
                      style={{
                          display: 'inline-block',
                          paddingLeft: '8px',
                          verticalAlign: 'middle'
                      }}
                  >
                      {item.metadata.places}
                  </Typography>
              </span>
              <span className={classes.itemOptions}>
                  {itemMouseOver && itemMouseOver.id === item.id && (
                      <IconButton
                          style={{ padding: 2, height: '35px', width: '35px' }}
                          onClick={() => {
                              this.setState({
                                  redirect: '/console/activity/execution/' + selected.id
                              });
                          }}
                      >
                          <Info />
                      </IconButton>
                  )}
              </span>
          </ListItem>
      );
  };

  render() {
      const { filters } = this.props;
      const { selected, redirect } = this.state;
      return (
          <React.Fragment>
              <DynamicList
                  selected={selected}
                  filters={filters}
                  provider={requests.getLogs}
                  subheaderBy={this.doDate}
                  subheaderRenderer={this.renderDate}
                  onLoad={this.scrollToBottom}
                  noDataMessage={
            <>
              {filters.id === undefined && filters.requests.length === 0 ? (
                  <Typography>
                  There are no requests yet. If you need some help visit our
                      <a
                          href="http://docs.smartmonkey.io/#/products/flake/README"
                          rel="noopener noreferrer"
                          target="_blank"
                      >
                          {' '}
                    documentation
                      </a>
                  .
                  </Typography>
              ) : (
                  <Typography>
                  There are no requests matching the search filters.
                  </Typography>
              )}
            </>
                  }
                  renderer={(item, idx) => (
                      <React.Fragment key={'container-' + item.id}>
                          {(() => {
                              switch (item.request) {
                              case 'optimizerV1':
                                  return this.renderOptimizerV1(item, idx);
                              case 'optimizerV1-get':
                                  return this.rendererDefault(item, idx);
                              case 'placesProfilerV1':
                                  return this.renderPlacesProfilerV1(item, idx);
                              default:
                                  return this.rendererDefault(item, idx);
                              }
                          })()}
                      </React.Fragment>
                  )}
              />
              <div ref={this.bottomDiv} />
              {redirect && <Redirect push to={redirect} />}
          </React.Fragment>
      );
  }
}

export default withStyles(styles)(RequestsList);
